import { getSubscriptionPlans } from './useSubscriptionPlans';
import { formatPrice } from './utils/formatPrice';

export interface NewTierPlan {
  key: 'one' | 'ultimate_2026' | 'black';
  title: string;
  price: string;
  priceValue: number;
  tagline: string;
  id: number | string;
  gatewayId: number | string;
}

// 'ultimate_2026' (não 'ultimate') pra não colidir com o plan_type do Ultimate legado,
// mantido no catálogo exclusivamente como fallback quando a precificação 2026 está desligada.
const NEW_TIER_TAGLINES: Record<NewTierPlan['key'], string> = {
  one: 'O essencial para começar',
  ultimate_2026: 'Mais produtividade no dia a dia',
  black: 'Máxima performance',
};

const NEW_TIERS: NewTierPlan['key'][] = ['one', 'ultimate_2026', 'black'];

export const getNewTierPlans = (): NewTierPlan[] =>
  NEW_TIERS.map((key): NewTierPlan | null => {
    const plan = getSubscriptionPlans({
      plan_type: key,
      billingCycle: 'monthly',
      hasJusProcessos: false,
      is_offer: false,
    });

    if (!plan) return null;

    return {
      key,
      title: plan.name,
      price: formatPrice(plan.amount, { hideCents: true }),
      priceValue: plan.amount,
      tagline: NEW_TIER_TAGLINES[key],
      id: plan.id,
      gatewayId: plan.gateway_id,
    };
  }).filter((plan): plan is NewTierPlan => plan !== null);
